// All of thes etiles should be rendered with trnansparent backgrounds, so they can be layered on top of the base chip tiles (eg to add decor on top of ground tiles, or to add height variation to the terrain with height tiles).
export const BASE_CHIP_TILES = {
    lightGrass: 0,
    mediumGrass: 1,
    darkGrass: 2,
    dyingGrass: 3,
    sand: 4,
    lightDirt: 5,
    mediumDirt: 6,
    darkDirt: 7,

    // ── Special tiles (not used in base chip) ─────────────────────────────────

    // Trees (for tree chipsheet) — each tree is 2 tiles wide and 2 tiles tall, with separate top and bottom halves to allow layering with the player avatar.
    lightTreeTopLeft: 8,
    lightTreeTopRight: 9,
    darkTreeTopLeft: 10,
    darkTreeTopRight: 11,
    autumnTreeTopLeft: 12,
    autumnTreeTopRight: 13,
    deadTreeTopLeft: 14,
    deadTreeTopRight: 15,
    lightTreeBottomLeft: 16,
    lightTreeBottomRight: 17,
    darkTreeBottomLeft: 18,
    darkTreeBottomRight: 19,
    autumnTreeBottomLeft: 20,
    autumnTreeBottomRight: 21,
    deadTreeBottomLeft: 22,
    deadTreeBottomRight: 23,
    // Tree columns (for another row of trees infront of the first, with same tops but different bottoms):
    // Note: these go between the top and bottom tree tiles (eg lightTreeColumnLeft is between lightTreeTopLeft and lightTreeBottomLeft) so that they can be used in the same tilemap layer as the top and bottom tree tiles.   
    lightTreeColumnLeft: 24,
    lightTreeColumnRight: 25,
    darkTreeColumnLeft: 26,
    darkTreeColumnRight: 27,
    autumnTreeColumnLeft: 28,
    autumnTreeColumnRight: 29,
    deadTreeColumnLeft: 30,
    deadTreeColumnRight: 31,
    // Tree columns staggered (for a more natural look, with some trees slightly infront of others):
    // Note: these go between the top and bottom tree tiles (eg a typical layout might be:
    //       colum 0  colum 1, column 2, column 3
    // row 0   empty,  treeTopLeft,  treeTopRight, empty
    // row 1   treeTopLeft, lightTreeColumnRightStaggered, lightTreeColumnLeftStaggered, treeTopRight
    // row 2   treeBottomLeft, treeBottomRight, treeBottomLeft, treeBottomRight
    // This would show 3 tree in a triangular layout, with the middle tree slightly behind the other two.
    lightTreeColumnLeftStaggered: 32,
    lightTreeColumnRightStaggered: 33,
    darkTreeColumnLeftStaggered: 34,
    darkTreeColumnRightStaggered: 35,
    autumnTreeColumnLeftStaggered: 36,
    autumnTreeColumnRightStaggered: 37,
    deadTreeColumnLeftStaggered: 38,
    deadTreeColumnRightStaggered: 39,

    // Bushes
    lightBush: 40,
    darkBush: 41,
    autumnBush: 42,
    deadBush: 43,

    // Wood
    smallStump: 44,
    largeStump: 45,
    // Horizontally oriented log tiles (for fallen trees, etc) — these go between the left and right tree tiles so they can be used in the same tilemap layer as the tree tops and bottoms.
    logLeft: 46,
    logRight: 47,
    // Vertically oriented log tiles (for fallen trees, etc) — these go between the top and bottom tree tiles so they can be used in the same tilemap layer as the tree tops and bottoms.    
    logTop: 63,
    logBottom: 71,

    // Plants
    grassTuft: 48,
    smallGrass: 49,
    deadGrassTuft: 50,
    deadSmallGrass: 51,
    whiteFlower: 52,
    pinkFlower: 53,
    blueFlower: 54,
    yellowFlower: 55,
    brownMushroom: 56,
    purpleMushroom: 57,
    smallLilypad: 58,
    largeLilypad: 59,

    // Puddles
    lightPuddle: 60,
    darkPuddle: 61,
    greenPuddle: 62,

    // Rocks
    smallRock: 64,
    largeRock: 65,

    // Other
    hole: 66,
    graveStone: 67,
    graveWoodenCross: 68,
    campfireUnlit: 69,
    summoningCircle: 70,

    // Height tiles (for vertical environment)


    // Ploughed field tiles (for farm environment)
    topLeftPlough: 152,
    topPlough: 153,
    topRightPlough: 154,
    leftPlough: 160,
    centerPlough: 161,
    rightPlough: 162,
    bottomLeftPlough: 168,
    bottomPlough: 169,
    bottomRightPlough: 170,
    isolatedPlough: 171,
    scarecrowTop: 155,
    scarecrowBottom: 163,
    cropShoot: 156,
    cropWheatTop: 157,
    cropCarrot: 158,
    cropSpinach: 159,
    cropDead: 164,
    cropWheatMiddle: 165,
    cropPumkin: 166,
    cropLettuce: 167,
    cropRose: 172,
    cropWheatBottom: 173,
    cropBeans: 174,
    cropBerries: 175,

    // Fences (direction denotes the direction that can be linked to another fence tile, eg fenceLeft can link to another fence tile on its left side, but not its right side. Fences can link to path tiles to form gates, but not to other fence tiles, so they need separate tiles for corners and standalone pieces.)
    fenceTopBottom: 176,
    fenceBotton: 177,
    fenceRightBottom: 178,
    fenceLeftBottom: 179,
    fenceLeft: 180,
    fenceLeftRightTop: 181,
    fenceLeftRightBottom: 182,
    fenceLeftRightTopBottom: 183,
    fenceLeftRight: 184,
    fenceTop: 185,
    fenceTopRight: 186,
    fenceLeftTop: 187,
    fenceRight: 188,
    fenceTopRightBottom: 189,
    fenceLeftTopBottom: 190,
    fenceIsolated: 191,

    ironFenceTopBotton: 192,
    ironFenceBotton: 193,
    ironFenceRightBottom: 194,
    ironFenceLeftBottom: 195,
    ironFenceLeft: 196,
    ironFenceLeftRightTop: 197,
    ironFenceLeftRightBottom: 198,
    ironFenceLeftRightTopBottom: 199,
    ironFenceLeftRight: 200,
    ironFenceTop: 201,
    ironFenceTopRight: 202,
    ironFenceLeftTop: 203,
    ironFenceRight: 204,
    ironFenceTopRightBottom: 205,
    ironFenceLeftTopBottom: 206,
    ironFenceIsolated: 207,

    stoneWallTopBotton: 208,
    stoneWallBotton: 209,
    stoneWallRightBottom: 210,
    stoneWallLeftBottom: 211,
    stoneWallLeft: 212,
    stoneWallLeftRightTop: 213,
    stoneWallLeftRightBottom: 214,
    stoneWallLeftRightTopBottom: 215,
    stoneWallLeftRight: 216,
    stoneWallTop: 217,
    stoneWallTopRight: 218,
    stoneWallLeftTop: 219,
    stoneWallRight: 220,
    stoneWallTopRightBottom: 221,
    stoneWallLeftTopBottom: 222,
    stoneWallIsolated: 223,

    portcullisTopLeft: 646,
    portcullisTopRight: 647,
    portcullisBottomLeft: 654,
    portcullisBottomRight: 655,

    // Other
    boardwalkVertical: 224,
    boardwalkHorizontal: 225,
    stoneWell: 226,
    bucketAndRope: 227,
    mailBox: 228,
    roadSignTop: 229,
    messageBoardTopLeft: 230,
    messageBoardTopRight: 231,
    boardwalkVerticalSupport: 232,
    boardwalkHorizontalSupport: 233,
    smallSign: 234,
    mediumSign: 235,
    largeSign: 236,
    roadSignBottom: 237,
    messageBoardBottomLeft: 238,
    messageBoardBottomRight: 239,

    // Various 240 - 287

    // Flooring
    woodFloor: 288,
    stoneFloor: 289,
    cobblestoneFloor: 290,
    quarteredFloor: 291,
    checkeredFloor: 292,
    redCarpetFloor: 293,
    fullLadderTop: 294,
    halfLadderTop: 295,
    darkWoodFloor: 296,
    darkStoneFloor: 297,
    darkCobblestoneFloor: 298,
    darkQuarteredFloor: 299,
    darkCheckeredFloor: 300,
    yellowCarpetFloor: 301,
    ladderBottom: 302,
    ladderIntoFloor: 303,
    parquetFloor: 304,
    smallStoneFloor: 305,   
    diagonalFloor: 306,
    fourByFourTileFloor: 307,
    meshFloor: 308,
    ornateFloor: 309,
    stepsUpFromLeft: 310,
    stepsUpFromRight: 311,
    darkParquetFloor: 312,
    goldSmallTileFloor: 313,
    darkDiagonalFloor: 314,
    darkFourByFourTileFloor: 315,
    lightMeshFloor: 316,
    blueOrnateFloor: 317,

    // Many more tiles up to 656 for various decor, furniture, etc.
    stoneCityWallTopBotton: 208,
    stoneCityWallBotton: 209,
    stoneCityWallRightBottom: 210,
    stoneCityWallLeftBottom: 211,
    stoneCityWallLeft: 212,
    stoneCityWallLeftRightTop: 213,
    stoneCityWallLeftRightBottom: 214,
    stoneCityWallLeftRightTopBottom: 215,
    stoneCityWallLeftRight: 216,
    stoneCityWallTop: 217,
    stoneCityWallTopRight: 218,
    stoneCityWallLeftTop: 219,
    stoneCityWallRight: 220,
    stoneCityWallTopRightBottom: 221,
    stoneCityWallLeftTopBottom: 222,
    stoneCityWallIsolated: 223,


    // Shop Signs
    weaponsSign: 656    ,
    armourSign: 657      ,
    bagSign: 658      ,
    foodSign: 659       ,
    drinkSign: 660      ,
    teaSign: 661        ,
    magicSign: 662      ,
    ringSign: 663       ,
    innSign: 664        ,
    healthSign: 665     ,
    appleSign: 666       ,
    bookSign: 667        ,
    goldSign: 668        ,
    wolfSign: 669        ,
    skullSign: 670       ,
    blankSign: 671     ,

    // Many more tiles

    // Storage
    lightPotWithLid: 856,
    lightPotWithoutLid: 857,
    darkPotWithLid: 858,
    darkPotWithoutLid: 859,
    crate: 860,
    chest: 861,
    strongChest: 862,
    goldChest: 863,
    fullBucket: 864,
    emptyBucket: 865,   
    logPile: 866,
    choppingBlock: 867,
    openCrate: 868,
    openChest: 869,
    openStrongChest: 870,
    openGoldChest: 871,
    sack: 872,
    hayStack: 873,
    pileOfSacks: 874,
    barrel: 875,
    emptyBasket: 876,
    appleBasket: 877,
    leafBasket: 878,
    mushroomBasket: 879,

    // Many More

    // Statues
    darkPillarTop:904,
    lightPillarTop:905,
    birdBathTop: 906,
    brazierTop: 907,
    knightTop:908,
    stripedShopAwningTop: 909,
    plainShowAwningTop:910,
    tallBushTop:911,
    darkPillarMiddle:912,
    lightPillarMiddle:913,
    birdBathMiddle:914,
    brazierBottom:915,
    knightBottom:916,
    stripedShopAwningMiddle: 917,
    plainShowAwningMiddle:918,
    tallBushPot:919,
    darkPillarBottom:920,
    lightPillarBottom:921,
    birdBathBottom: 922,

    angelStatueTop:                    923,
    gargoyleTop:                       924,
    stripedShopAwningBottom:           925,
    plainShowAwningBottom:             926,
    spikyPlantTop:                     927,
    fountainTopLeft:                   928,
    fountainTopMiddle:                 929,
    fountainTopRight:                  930,

    angelStatueBottom:                 931,
    gargoyleBottom:                    932,
    stripedShopAwningWithSupport:      933,
    plainShowAwningWithSupport:        934,
    spikyPlantBottom:                  935,
    fountainMidLeft:                   936,
    fountainMidMiddle:                 937,
    fountainMidRight:                  938,

    memorialTopLeft:                   939, // NOTE: conflicts with royalBedTopLeft:939 — verify
    memorialTopRight:                  940,
    stripedShopAwningSupportPillar:    941,
    plainShowAwningSupportPillar:      942,
    potOfFlowers:                      943,
    fountainBotLeft:                   944,
    fountainBotMiddle:                 945,
    fountainBotRight:                  946,

    memorialBotLeft:                   947,
    memorialBotRight:                  948,
    stripedShopAwningSupportPillarBot: 949,
    plainShowAwningSupportPillarBot:   950,
    emptyPotOfFlowers:                 951,

    // Outdoor furniture / decor (verify exact IDs)
    lampPostTop:    907,
    lampPostBottom: 915,
    benchLeft:      848,
    benchMiddle:    849,
    benchRight:     850,
    flowerPotLeft:  943,
    flowerPotRight: 943,

    // Furniture sets (beds, tables, chairs) — verify exact IDs, 666 = placeholder
    // 4-tile royal bed (confirmed)
    royalBedTopLeft:779,
    royalBedTopRight:780,
    royalBedBottonLeft:787,
    royalBedBottomRight:788,
    royalBedTopLeftOverlay:795,
    royalBedTopRightOverlay:796,
    royalBedBottonLeftOverlay:803,
    royalBedBottomRightOverlay:804,


    // 2-tile bed (vertical, head on top side) - with overlay so npc can get into bed
    simpleBedHead:  776, // decor layer
    simpleBedFoot:  784, // decor layer
    simpleBedHeadOverlay: 792, // above npc layer
    simpleBedFootOverlay: 800, // above npc layer

    normalBedHead:  777, // decor layer
    normalBedFoot:  785, // decor layer
    normalBedHeadOverlay: 793, // above npc layer
    normalBedFootOverlay: 801, // above npc layer

    luxuryBedHead:  778, // decor layer
    luxuryBedFoot:  786, // decor layer
    luxuryBedHeadOverlay: 794, // above npc layer
    luxuryBedFootOverlay: 802, // above npc layer

    // Chairs 
    stool:  724,
    stoolDark:    754,
    stoolWithCover:  755,
    stoolWithPurpleCushion: 756,

    // Tables (2×2 minimum top-view - can be tiled to make any size)
    smallTableTopLeft:     717,
    smallTableTopMiddle: 718,
    smallTableTopRight:    719,
    smallTableMiddleLeft:     725,
    smallTableMiddleMiddle: 726,
    smallTableMiddleRight:    727,
    smallTableBottomLeft:  733,
    smallTableBottomMiddle:  734,
    smallTableBottomRight: 735,

    roundTable:            716,
    roundTableWithCloth:            747,

    // Bookshelf / shelf (2 tiles tall)
    bookshelfTop:    715,
    bookshelfBottom: 723,

    // Counter / bar (single tile, top-view)

    counterTopVerticalTop: 672,
    counterTopVerticalMiddle: 680,
    counterTopVerticalBottom: 688,
    counterTopHorizontalLeft: 673,
    counterTopHorizontalMiddle: 674,
    counterTopHorizontalRight: 675,
    counterTopTopLeft: 681,
    counterTopTopRight: 682,
    counterTopBottomLeft: 689,
    counterTopBottomRight: 690,
    counterTop: 683,


    counterTopDarkWoodVerticalTop: 676,
    counterTopDarkWoodVerticalMiddle: 684,
    counterTopDarkWoodVerticalBottom: 692,
    counterTopDarkWoodHorizontalLeft: 677,
    counterTopDarkWoodHorizontalMiddle: 678,
    counterTopDarkWoodHorizontalRight: 679,
    counterTopDarkWoodTopLeft: 685,
    counterTopDarkWoodTopRight: 686,
    counterTopDarkWoodBottomLeft: 693,
    counterTopDarkWoodBottomRight: 694,
    counterTopDarkWood: 687,


    counterTopMahoganyVerticalTop: 695,
    counterTopMahoganyVerticalMiddle: 703,
    counterTopMahoganyVerticalBottom: 711,
    counterTopMahoganyHorizontalLeft: 698,
    counterTopMahoganyHorizontalMiddle: 699,
    counterTopMahoganyHorizontalRight: 700,
    counterTopMahoganyTopLeft: 701,
    counterTopMahoganyTopRight: 702,
    counterTopMahoganyBottomLeft: 709,
    counterTopMahoganyBottomRight: 710,
    counterTopMahogany: 691,

    washingLineEmptyTopLeft: 246,
    washingLineEmptyTopRight: 247,
    washingLineEmptyBottomLeft: 254,
    washingLineEmptyBottomRight: 255,
    washingLineTopLeft: 262,
    washingLineTopRight: 263,
    washingLineBottomLeft: 270,
    washingLineBottomRight: 271,
    washingLineClothesTopLeft: 278,
    washingLineClothesTopRight: 279,
    washingLineClothesBottomLeft: 286,
    washingLineClothesBottomRight: 287,

    goldenCross: 614,
    stoneCross: 615,
    worldMapTopLeft: 624,
    worldMapTopRight: 625,
    wantedPosterTop: 627,
    worldMapBottomLeft: 632,
    worldMapBottomRight: 633,
    wantedPosterBottom: 635,
    plateEmpty: 960,
    bottlesOfLiquor: 972,
    potions: 985,


    chimneyTop: 567,
    chimneyMiddle: 575,
    chimneyBottom: 583,
    chimneyShort: 591,
    wallNotesTop: 626,
    wallNotesBottom: 634,
    strongDoorTopLeft: 640,
    strongDoorTopRight: 641,
    strongDoorBottomLeft: 648,
    strongDoorBottomRight: 649,
    cauldren: 764,
    wallClock: 808,
    wallClock2: 810,
    mugOfCoffee: 973,
    teapot: 974,
    cupOfTea: 975,
    rolledMap: 976,
    note: 977,
    pileOfPapers: 978,
    quilAndInk: 979,
    smallSack: 986,
    crownOfCushon: 1018,
    teddy: 1027,
    doll: 1028,
    toy: 1029,
    sword: 1052,
    axe: 1053,
    skull: 1054,
    key: 1055,


    shieldMounted: 1047,
    roundShieldFloor: 1062,
   

    // Desk (single tile)
    deskTop: 746,

    // Fireplace (3 tiles wide, 2 tiles tall)
    fireplaceTopLeft:    832,
    fireplaceTopMiddle:    833,
    fireplaceTopRight:    834,
    fireplaceBottomLeft: 840,
    fireplaceBottomMiddle: 841,
    fireplaceBottomRight: 842,

    // Candles / lighting
    candlestickUnlit:  1002,

    candlestickLitTop:  995,
    candlestickLitBottom:  1003,
    wallTorch:    666,
    floorLantern: 666,

    // Windows (placed in walls) — 4 variants
    windowTop:    592, windowTop2:    593, windowTop3:    594, windowTop4:    595,
    windowBottom: 600, windowBottom2: 601, windowBottom3: 602, windowBottom4: 603,

    // Internal windows - top 596 to 599, bottom 604 to 607


    bellTowerTop: 612,
    bellTowerBottom: 620,
    

    // Interior doors (2 tiles tall)
    doorTop:    535,
    doorBottom: 543,

    // Stairs
    stairsUp:   666,
    stairsDown: 666,

    // Stairs that go in front of a building and go up to a front door
    stoneStairsUpLeftTop:331,
    stoneStairsUpRightTop:333,    
    stoneStairsUpLeftMiddle:339,
    stoneStairsUpMiddleMiddle:340,
    stoneStairsUpRightMiddle:341,    
    stoneStairsUpLeftBottom:347,
    stoneStairsUpMiddleBottom:348,
    stoneStairsUpRightBottom:349,

    // Decorative floor / wall items
    rugTopLeft:     837,
    rugTopMid: 838,
    rugTopRight:    839,
    // middle row 845,846,847
    rugMidLeft: 845,
    rugMidMid: 846,
    rugMidRight: 847,
    rugBottomLeft:  853,
    rugBottomMid: 854,
    rugBottomRight: 855,
    painting:       666,
    mirrorTop:      629,
    mirrorBottom:   637,

    // Items that are placable on tables, etc
    closedBook: 952,
    openBook: 953,
    blueclosedBook: 954,
    blueopenBook: 955,
    blackclosedBook: 956,
    blackopenBook: 957,
    greenclosedBook: 958,
    greenopenBook: 959,

    bunchOfHerbs: 984,

    gift:992,
    smallChest:993,
    pileOfCoins:994,
    pendant: 1008,


    // Exterior Walls

    // Wood Wall starts at 352
    woodWallLeftTop:       352, woodWallMiddleTop:    353, woodWallRightTop:    354,
    woodWallPillarTop:     355, woodWallShadowTop:    356, woodWallShadowRightTop:    357,
    woodWallDoorArchTop:   358, woodWallDoorTop:      359,
    woodWallLeftBottom:    360, woodWallMiddleBottom: 361, woodWallRightBottom: 362,
    woodWallPillarBottom:  363, woodWallShadowBottom: 364, woodWallShadowRightBottom: 365,
    woodWallDoorBottom:    367,

    // Tudor Frame starts at 368
    tudorFrameLeftTop:       368, tudorFrameMiddleTop:    369, tudorFrameRightTop:    370,
    tudorFramePillarTop:     371, tudorFrameShadowTop:    372, tudorFrameShadowRightTop:    373,
    tudorFrameDoorArchTop:   374, tudorFrameDoorTop:      375,
    tudorFrameLeftBottom:    376, tudorFrameMiddleBottom: 377, tudorFrameRightBottom: 378,
    tudorFramePillarBottom:  379, tudorFrameShadowBottom: 380, tudorFrameShadowRightBottom: 381,
    tudorFrameDoorBottom:    383,

    // Rendered Brick starts at 384
    renderedBrickLeftTop:       384, renderedBrickMiddleTop:    385, renderedBrickRightTop:    386,
    renderedBrickPillarTop:     387, renderedBrickShadowTop:    388, renderedBrickShadowRightTop:    389,
    renderedBrickDoorArchTop:   390, renderedBrickDoorTop:      391,
    renderedBrickLeftBottom:    392, renderedBrickMiddleBottom: 393, renderedBrickRightBottom: 394,
    renderedBrickPillarBottom:  395, renderedBrickShadowBottom: 396, renderedBrickShadowRightBottom: 397,
    renderedBrickDoorBottom:    399,

    // Brick starts at 400
    brickLeftTop : 400, // Can be repeated for additional rows to add height
    brickLeftBottom : 408,
    brickMiddleTop : 401,
    brickMiddleBottom : 409,
    brickRightTop : 402,
    brickRightBottom : 410,
    brickPillarTop: 403,
    brickPillarBottom: 411,
    brickShadowTop: 404, // goes to teh right of the pilar for depth
    brickShadowRightTop: 405,
    brickShadowBottom: 412, // goes to teh right of the pilar for depth
    brickShadowRightBottom: 413,
    brickDoorArchTop: 406, // Texture behind door decor
    brickDoorTop: 407,
    brickDoorBottom: 415,

    // White Stone - 416
    whiteStoneLeftTop:       416, whiteStoneMiddleTop:    417, whiteStoneRightTop:    418,
    whiteStonePillarTop:     419, whiteStoneShadowTop:    420, whiteStoneShadowRightTop:    421,
    whiteStoneDoorArchTop:   422, whiteStoneDoorTop:      423,
    whiteStoneLeftBottom:    424, whiteStoneMiddleBottom: 425, whiteStoneRightBottom: 426,
    whiteStonePillarBottom:  427, whiteStoneShadowBottom: 428, whiteStoneShadowRightBottom: 429,
    whiteStoneDoorBottom:    431,

    // Dark Stone - 432
    darkStoneLeftTop:       432, darkStoneMiddleTop:    433, darkStoneRightTop:    434,
    darkStonePillarTop:     435, darkStoneShadowTop:    436, darkStoneShadowRightTop:    437,
    darkStoneDoorArchTop:   438, darkStoneDoorTop:      439,
    darkStoneLeftBottom:    440, darkStoneMiddleBottom: 441, darkStoneRightBottom: 442,
    darkStonePillarBottom:  443, darkStoneShadowBottom: 444, darkStoneShadowRightBottom: 445,
    darkStoneDoorBottom:    447,

    // Castle Stone - 448
    castleStoneLeftTop:       448, castleStoneMiddleTop:    449, castleStoneRightTop:    450,
    castleStonePillarTop:     451, castleStoneShadowTop:    452, castleStoneShadowRightTop:    453,
    castleStoneDoorArchTop:   454, castleStoneDoorTop:      455,
    castleStoneLeftBottom:    456, castleStoneMiddleBottom: 457, castleStoneRightBottom: 458,
    castleStonePillarBottom:  459, castleStoneShadowBottom: 460, castleStoneShadowRightBottom: 461,
    castleStoneDoorBottom:    463,

    // Ornate Stone - 464
    ornateStoneLeftTop:       464, ornateStoneMiddleTop:    465, ornateStoneRightTop:    466,
    ornateStonePillarTop:     467, ornateStoneShadowTop:    468, ornateStoneShadowRightTop:    469,
    ornateStoneDoorArchTop:   470, ornateStoneDoorTop:      471,
    ornateStoneLeftBottom:    472, ornateStoneMiddleBottom: 473, ornateStoneRightBottom: 474,
    ornateStonePillarBottom:  475, ornateStoneShadowBottom: 476, ornateStoneShadowRightBottom: 477,
    ornateStoneDoorBottom:    479,

    // Reinforced Stone - 480
    reinforcedStoneLeftTop:       480, reinforcedStoneMiddleTop:    481, reinforcedStoneRightTop:    482,
    reinforcedStonePillarTop:     483, reinforcedStoneShadowTop:    484, reinforcedStoneShadowRightTop:    485,
    reinforcedStoneDoorArchTop:   486, reinforcedStoneDoorTop:      487,
    reinforcedStoneLeftBottom:    488, reinforcedStoneMiddleBottom: 489, reinforcedStoneRightBottom: 490,
    reinforcedStonePillarBottom:  491, reinforcedStoneShadowBottom: 492, reinforcedStoneShadowRightBottom: 493,
    reinforcedStoneDoorBottom:    495,

    // Wooden Slats - 496
    woodenSlatsLeftTop:       496, woodenSlatsMiddleTop:    497, woodenSlatsRightTop:    498,
    woodenSlatsPillarTop:     499, woodenSlatsShadowTop:    500, woodenSlatsShadowRightTop:    501,
    woodenSlatsDoorArchTop:   502, woodenSlatsDoorTop:      503,
    woodenSlatsLeftBottom:    504, woodenSlatsMiddleBottom: 505, woodenSlatsRightBottom: 506,
    woodenSlatsPillarBottom:  507, woodenSlatsShadowBottom: 508, woodenSlatsShadowRightBottom: 509,
    woodenSlatsDoorBottom:    511,

    // Interior - Striped Wallpaper - 512 (row layout: Left Middle Right Pillar Shadow ShadowRight DoorArch Door)
    interiorWallStripedTopLeft:          512,
    interiorWallStripedTopMiddle:        513,
    interiorWallStripedTopRight:         514,
    interiorWallStripedPillarTop:        515,
    interiorWallStripedShadowTop:        516,
    interiorWallStripedShadowRightTop:   517,
    interiorWallStripedDoorArchTop:      518,
    interiorWallStripedDoorTop:          519,
    interiorWallStripedBottomLeft:       520,
    interiorWallStripedBottomMiddle:     521,
    interiorWallStripedBottomRight:      522,
    interiorWallStripedPillarBottom:     523,
    interiorWallStripedShadowBottom:     524,
    interiorWallStripedShadowRightBottom:525,
    interiorWallStripedDoorBottom:       527,
    // Interior - White Wallpaper - 528
    interiorWallWhiteTopLeft:            528,
    interiorWallWhiteTopMiddle:          529,
    interiorWallWhiteTopRight:           530,
    interiorWallWhitePillarTop:          531,
    interiorWallWhiteShadowTop:          532,
    interiorWallWhiteShadowRightTop:     533,
    interiorWallWhiteDoorArchTop:        534,
    interiorWallWhiteDoorTop:            535,
    interiorWallWhiteBottomLeft:         536,
    interiorWallWhiteBottomMiddle:       537,
    interiorWallWhiteBottomRight:        538,
    interiorWallWhitePillarBottom:       539,
    interiorWallWhiteShadowBottom:       540,
    interiorWallWhiteShadowRightBottom:  541,
    interiorWallWhiteDoorBottom:         543,

    // Prison Cell Railings - 544
    prisonRailingsTopLeft:          544,
    prisonRailingsTopMiddle:        545,
    prisonRailingsTopRight:         546,
    prisonRailingsPillarTop:        547,
    prisonRailingsShadowTop:        548,
    prisonRailingsShadowRightTop:   549,
    prisonRailingsDoorArchTop:      550,
    prisonRailingsDoorTop:          551,
    prisonRailingsBottomLeft:       552,
    prisonRailingsBottomMiddle:     553,
    prisonRailingsBottomRight:      554,
    prisonRailingsPillarBottom:     555,
    prisonRailingsShadowBottom:     556,
    prisonRailingsShadowRightBottom:557,
    prisonRailingsDoorBottom:       559,
   

    // Prison Cell Railings - 544

    swordMountedLeft: 1014,
    swordMountedRight: 1015,
    helmetTop: 1016,
    wizardHatTop: 1017,
    rapierMountedLeft: 1022,
    rapierMountedRight: 1023,
    helmetBottom: 1024,
    wizardHatBottom: 1025,
    suitOfArmourTop: 1032,
    suitOfArmourBottom: 1040,
   




    // Roofs - 4 rows , repeat for width of building
    woodRoofRow1 : 560,
    woodRoofRow2 : 568,
    woodRoofRow3 : 576,
    woodRoofRow4 : 584,

    yellowSlateRoofRow1 : 561,
    yellowSlateRoofRow2 : 569,
    yellowSlateRoofRow3 : 577,
    yellowSlateRoofRow4 : 585,

    blueSlateRoofRow1: 562,
    blueSlateRoofRow2: 570,
    blueSlateRoofRow3: 578,
    blueSlateRoofRow4: 586,

    redSlateRoofRow1: 563,
    redSlateRoofRow2: 571,
    redSlateRoofRow3: 579,
    redSlateRoofRow4: 587,

    greySlateRoofRow1 : 564,
    greySlateRoofRow2 : 572,
    greySlateRoofRow3 : 580,
    greySlateRoofRow4 : 588,

    metalRoofRow1 : 565,
    metalRoofRow2 : 573,
    metalRoofRow3 : 581,
    metalRoofRow4 : 589,

    strawRoofRow1 : 566,
    strawRoofRow2 : 574,
    strawRoofRow3 : 582,
    strawRoofRow4 : 590,





        wallArchTopLeft: 241,
    wallArchTopMiddle: 242,
    wallArchTopRight: 243,
    wallArchLeft: 244,
    wallArchFill: 250,

    wallArchRight: 245,
  
    roundWindowLit:609,
    cellWindowLit:610,
    roundWindowUnlit: 617,
    cellWindowUnlit: 618,
   

    archStoneDark: 258,




        archwayWallTop: 240,
    archwayWall: 248,
    archwayWallRight: 249,
    archwayWallLeft: 251,
    archwayWallTopLeft: 252,
    archwayWallTopShadow: 256,
    archwayWallRight2: 257,
    archwallLeft2: 259,
    archTopRight: 260,
  
      stainedGlassWindow1Top: 622,
    stainedGlassWindow2Top: 623,
    stainedGlassWindow1Mid: 630,
    stainedGlassWindow2Mid: 631,
    stainedGlassWindow1Bottom: 638,
    stainedGlassWindow2Bot: 639,

        paintingLandscapeTop: 628,
    paintingLandscapeBottom: 636,
    altarTopLeft: 813,
    altarTopMid: 814,
    altarTopRight: 815,
    altarMidLeft: 821,
    altarMidMid: 822,
    altarMidRight: 823,
    altarBotLeft: 829,
    altarBotMid: 830,
    altarBotRight: 831,

        woodStepsUpRightTop: 318,
    woodStepsUpRightBot: 326,
    stoneStepsUpRight: 334,

        bridgeHorizontalTopLeft: 264,
    bridgeHorizontalTopMid: 265,
    bridgeHorizontalTopRight: 266,
    bridgeHorizontalMidLeft: 272,
    bridgeHorizontalMidMid: 273,
    bridgeHorizontalMidRight: 274,
    bridgeHorizontalBotLeft: 280,
    bridgeHorizontalBotMid: 281,
    bridgeHorizontalBotRight: 282,

    whiteFloorBoards: 320,
    greenTiles: 321,
    dryMudFloor: 322,
    dustPatchFloor: 323,
    shinyGradientTileFLoor: 324,
    brickPaveFloor: 325,
    brownStairCarpet: 329,
    redStairCarpet: 332,
    stoneStepsUpRightTop: 342,
    stoneStepsUpRightBot: 350,

        bellTowerEmptyTop: 611,
    bellTowerEmptyBot: 619,
    stoneFireplaceMidTop: 809,
    woodenThroneTop: 811,
    goldenThroneTop: 812,
    stoneFireplaceMidLeft: 816,
    stoneFireplaceMidMid: 817,
    stoneFireplaceMidRight: 818,
    woodenThroneBot: 819,
    goldenThroneBot: 820,
    stoneFireplaceBottomLeft: 824,
    stoneFireplaceBottomMid: 825,
    stoneFireplaceBottomRight: 826,
    evilBannerTop: 827,
    bannerTop: 828,
    evilBannerBot: 835,
    bannerBot: 836,
    pianoTL: 843,
    pianoTR: 844,
    pianoBL: 851,
    pianoBR: 852,
    stackOfHayTL: 880,
    stackOfHayTR: 881,
    stackOfSacksTL: 882,
    stackOfSacksTR: 883,
    stackOfBarrelsTL: 884,
    stackOfBarrelsTR: 885,
    stackOfHayML: 888,
    stackOfHayMR: 889,
    stackOfSacksML: 890,
    stackOfSacksMR: 891,
    stackOfBarrelsML: 892,
    stackOfBarrelsMR: 893,
    stackOfHayLB: 896,
    stackOfHayRB: 897,
    stackOfSacksBL: 898,
    stackOfSacksBR: 899,
    stackOfBarrelsBL: 900,
    stackOfBarrelsBR: 901,
    candelabraTopLit: 988,
    lanternTopUnlit: 989,
    lanternTopLit: 990,
    candelabraTopUnlit: 996,
    lanternBottomUnlit: 997,
    lanternBotLit: 998,
    candelabraBottom: 1004,

        stackOfCratesTL: 886,
    stackOfCratesTR: 887,
    stackOfCratesML: 894,
    stackOfCratesMR: 895,
    stackOfCratesBL: 902,
    stackOfCratesBR: 903,
    cheeseWheel: 980,
    apples: 981,
    bread: 982,
    roastMeat: 983,
    crystalBall: 987,
    cookingPotTop: 991,
    cookingPotBot: 999,

        // ── Crystal tiles — individual 32×32 PNGs from /nodemap/32x32/ ───────────
    // Global IDs 10000–10039; resolved to their source files via EXTENDED_TILE_REFS.
    black_crystal1:       10000,
    black_crystal2:       10001,
    black_crystal3:       10002,
    black_crystal4:       10003,
    blue_crystal1:        10004,
    blue_crystal2:        10005,
    blue_crystal3:        10006,
    blue_crystal4:        10007,
    dark_red_crystal1:    10008,
    dark_red_crystal2:    10009,
    dark_red_crystal3:    10010,
    dark_red_crystal4:    10011,
    green_crystal1:       10012,
    green_crystal2:       10013,
    green_crystal3:       10014,
    green_crystal4:       10015,
    pink_crystal1:        10016,
    pink_crystal2:        10017,
    pink_crystal3:        10018,
    pink_crystal4:        10019,
    red_crystal1:         10020,
    red_crystal2:         10021,
    red_crystal3:         10022,
    red_crystal4:         10023,
    violet_crystal1:      10024,
    violet_crystal2:      10025,
    violet_crystal3:      10026,
    violet_crystal4:      10027,
    white_crystal1:       10028,
    white_crystal2:       10029,
    white_crystal3:       10030,
    white_crystal4:       10031,
    yellow_green_crystal1:10032,
    yellow_green_crystal2:10033,
    yellow_green_crystal3:10034,
    yellow_green_crystal4:10035,
    yellow_crystal1:      10036,
    yellow_crystal2:      10037,
    yellow_crystal3:      10038,
    yellow_crystal4:      10039,


    bridgeVertTopLeft: 267,
    bridgeVertTopMid: 268,
    bridgeVertTopRight: 269,
    bridgeVertMidLeft: 275,
    bridgeVertMidMid: 276,
    bridgeVertMidRight: 277,
    bridgeVertBotLeft: 283,
    bridgeVertBotMid: 284,
    bridgeVertBotRight: 285,

        ropeBot: 81,
    ropeTop: 93,
    ropeMid: 101,
    beanstalkTop: 134,
    beanstalkMid: 142,
    beanstalkBot: 150,

        squareTable: 708,
    tallDresserTop: 712,
    shortDresserTop: 713,
    tallDresserBottom: 720,
    shortDresserBottom: 721,
    tallMirrorTop: 760,
    stoneOven: 761,
    stoneEmptySink: 762,
    stoneFullSink: 763,
    tallMirrorBot: 768,
    gasOven: 769,
    woodenUnitEmptySink: 770,
    woodenUnit: 771,
    woodenUnitFullSink: 772,

        redCurtainTop: 696,
    whiteCurtainTop: 697,
    redCurtainBot: 704,
    whiteCurtainBot: 705,
    redCurtainMid: 706,
    whiteCurtainMid: 707,
    plateDougnuts: 961,
    plateSteak: 962,
    plateCookedFish: 963,
    platePastaAndSauce: 964,
    bowlOfSoup: 965,
    plateOfStew: 966,
    plateSliceOfCake: 967,
    potPinkFlower: 1000,
    potRedFlower: 1001,
    bombs: 1009,
    pairOfDaggers: 1010,

        parkBenchLeft: 11018,
    parkBenchMid: 11019,
    parkBenchRight: 11020,

        manacles: 20178,
    harp: 20179,
    ocorina: 20181,
    horn: 20184,
    candy: 20252,
  // ── Pictsquare2021 named tiles (globalId = 11000 + localTileIndex) ──
  wantedSign:          11001,   // localId 1
      palaceStepsTopLeft: 11183,
    palaceStepsTopRight: 11187,
  palaceStepsLeft:     11244,   // localId 244
  palaceStepsMidLeft:  11245,
  palaceStepsMid:      11246,
  palaceStepsMidRight: 11247,
  palaceStepsRight:    11248,
  palaceStepsBotLeft:     11305,
  palaceStepsBotMidLeft:  11306,
  palaceStepsBotMid:      11307,
  palaceStepsBotMidRight: 11308,
  palaceStepsBotRight:    11309,
  trayOfDrinks: 12068,          // localId 1068
  pumpkin1Lit:  13497,          // localId 2497
  goldFish:     13762,          // localId 2762


      floatingDuck1TL: 12056,
    floatingDuck1TM: 12057,
    floatingDuck1TR: 12058,
    floatingwatermellon: 12062,
    floatingDuck1BL: 12117,
    floatingDuck1BM: 12118,
    floatingDuck1BR: 12119,
    floatingDuck1: 12129,
    floatingDuck2: 12190,

        tinyMushroomPatch: 25228,
    bigMushroom: 25229,
    mushroomCluster: 25230,
    crateOfFish: 25554,
    crateOfWine: 25555,
    crateOfBundles: 25556,
    sackOfFlour: 25557,
    sackOfPotatoes: 25558,
    sackOfOnions: 25559,
    basketOfTomatoes: 25560,
    basketOfLettuce: 25561,
    basketOrPeppers: 25562,
    basketOfMelons: 25563,

        coveredCauldren: 25540,
    upendedLogs: 25541,
    choppingBlockNoAxe: 25542,
    crate1: 25552,
    closedCrate: 25553,
    bountyBoardTL: 25612,
    bountyBoardTR: 25613,
    bountyBoardBL: 25624,
    bountyBoardBR: 25625,

        heavyStoneDoorTopLeft: 642,
    heavyStoneDoorTopRight: 643,
    heavyStoneDoorBottomLeft: 650,
    heavyStoneDoorBottomRight: 651,
        goldDoorTopLeft: 644,

            puddles: 25243,
    bigPuddleLeft: 25244,
    bigPuddleRight: 25245,

    bigTreeStumpLeft: 25217,
    bigTreeStumpRight: 25218,

    // ── Animated doors (see doorTiles.ts) ──────────────────────────────────
    // Single-leaf: {material}Door{Above|Top|Bottom}Anim{1|2|3} — role is the
    // stacked tile row (Above/Top/Bottom = ty-3/ty-2/ty-1), Anim1/2/3 is the
    // closed/opening/open frame.
    // woodWall -> door1 band0 col0
    woodWallDoorAboveAnim1: 26000,
    woodWallDoorAboveAnim2: 26001,
    woodWallDoorAboveAnim3: 26002,
    woodWallDoorTopAnim1: 26006,
    woodWallDoorTopAnim2: 26007,
    woodWallDoorTopAnim3: 26008,
    woodWallDoorBottomAnim1: 26012,
    woodWallDoorBottomAnim2: 26013,
    woodWallDoorBottomAnim3: 26014,
    hammer: 20164,
    // whiteStone -> door1 band0 col3
    whiteStoneDoorAboveAnim1: 26003,
    whiteStoneDoorAboveAnim2: 26004,
    whiteStoneDoorAboveAnim3: 26005,
    whiteStoneDoorTopAnim1: 26009,
    whiteStoneDoorTopAnim2: 26010,
    whiteStoneDoorTopAnim3: 26011,
    whiteStoneDoorBottomAnim1: 26015,
    whiteStoneDoorBottomAnim2: 26016,
    whiteStoneDoorBottomAnim3: 26017,

    // tudorFrame -> door1 band1 col0
    tudorFrameDoorAboveAnim1: 26018,
    tudorFrameDoorAboveAnim2: 26019,
    tudorFrameDoorAboveAnim3: 26020,
    tudorFrameDoorTopAnim1: 26024,
    tudorFrameDoorTopAnim2: 26025,
    tudorFrameDoorTopAnim3: 26026,
    tudorFrameDoorBottomAnim1: 26030,
    tudorFrameDoorBottomAnim2: 26031,
    tudorFrameDoorBottomAnim3: 26032,

    // darkStone -> door1 band1 col3
    darkStoneDoorAboveAnim1: 26021,
    darkStoneDoorAboveAnim2: 26022,
    darkStoneDoorAboveAnim3: 26023,
    darkStoneDoorTopAnim1: 26027,
    darkStoneDoorTopAnim2: 26028,
    darkStoneDoorTopAnim3: 26029,
    darkStoneDoorBottomAnim1: 26033,
    darkStoneDoorBottomAnim2: 26034,
    darkStoneDoorBottomAnim3: 26035,

    // brick -> door1 band3 col0
    brickDoorAboveAnim1: 26054,
    brickDoorAboveAnim2: 26055,
    brickDoorAboveAnim3: 26056,
    brickDoorTopAnim1: 26060,
    brickDoorTopAnim2: 26061,
    brickDoorTopAnim3: 26062,
    brickDoorBottomAnim1: 26066,
    brickDoorBottomAnim2: 26067,
    brickDoorBottomAnim3: 26068,

    // castleStone -> door1 band2 col3
    castleStoneDoorAboveAnim1: 26039,
    castleStoneDoorAboveAnim2: 26040,
    castleStoneDoorAboveAnim3: 26041,
    castleStoneDoorTopAnim1: 26045,
    castleStoneDoorTopAnim2: 26046,
    castleStoneDoorTopAnim3: 26047,
    castleStoneDoorBottomAnim1: 26051,
    castleStoneDoorBottomAnim2: 26052,
    castleStoneDoorBottomAnim3: 26053,

    // renderedBrick -> door1 band2 col0
    renderedBrickDoorAboveAnim1: 26036,
    renderedBrickDoorAboveAnim2: 26037,
    renderedBrickDoorAboveAnim3: 26038,
    renderedBrickDoorTopAnim1: 26042,
    renderedBrickDoorTopAnim2: 26043,
    renderedBrickDoorTopAnim3: 26044,
    renderedBrickDoorBottomAnim1: 26048,
    renderedBrickDoorBottomAnim2: 26049,
    renderedBrickDoorBottomAnim3: 26050,

    // interiorWallWhite -> door2 band3 col0
    interiorWallWhiteDoorAboveAnim1: 27054,
    interiorWallWhiteDoorAboveAnim2: 27055,
    interiorWallWhiteDoorAboveAnim3: 27056,
    interiorWallWhiteDoorTopAnim1: 27060,
    interiorWallWhiteDoorTopAnim2: 27061,
    interiorWallWhiteDoorTopAnim3: 27062,
    interiorWallWhiteDoorBottomAnim1: 27066,
    interiorWallWhiteDoorBottomAnim2: 27067,
    interiorWallWhiteDoorBottomAnim3: 27068,

    // ornateStone -> door1 band3 col3
    ornateStoneDoorAboveAnim1: 26057,
    ornateStoneDoorAboveAnim2: 26058,
    ornateStoneDoorAboveAnim3: 26059,
    ornateStoneDoorTopAnim1: 26063,
    ornateStoneDoorTopAnim2: 26064,
    ornateStoneDoorTopAnim3: 26065,
    ornateStoneDoorBottomAnim1: 26069,
    ornateStoneDoorBottomAnim2: 26070,
    ornateStoneDoorBottomAnim3: 26071,

    // reinforcedStone -> door2 band0 col0
    reinforcedStoneDoorAboveAnim1: 27000,
    reinforcedStoneDoorAboveAnim2: 27001,
    reinforcedStoneDoorAboveAnim3: 27002,
    reinforcedStoneDoorTopAnim1: 27006,
    reinforcedStoneDoorTopAnim2: 27007,
    reinforcedStoneDoorTopAnim3: 27008,
    reinforcedStoneDoorBottomAnim1: 27012,
    reinforcedStoneDoorBottomAnim2: 27013,
    reinforcedStoneDoorBottomAnim3: 27014,

    // prisonRailings -> door2 band0 col3
    prisonRailingsDoorAboveAnim1: 27003,
    prisonRailingsDoorAboveAnim2: 27004,
    prisonRailingsDoorAboveAnim3: 27005,
    prisonRailingsDoorTopAnim1: 27009,
    prisonRailingsDoorTopAnim2: 27010,
    prisonRailingsDoorTopAnim3: 27011,
    prisonRailingsDoorBottomAnim1: 27015,
    prisonRailingsDoorBottomAnim2: 27016,
    prisonRailingsDoorBottomAnim3: 27017,

    // woodenSlats -> door2 band1 col0
    woodenSlatsDoorAboveAnim1: 27018,
    woodenSlatsDoorAboveAnim2: 27019,
    woodenSlatsDoorAboveAnim3: 27020,
    woodenSlatsDoorTopAnim1: 27024,
    woodenSlatsDoorTopAnim2: 27025,
    woodenSlatsDoorTopAnim3: 27026,
    woodenSlatsDoorBottomAnim1: 27030,
    woodenSlatsDoorBottomAnim2: 27031,
    woodenSlatsDoorBottomAnim3: 27032,

    // interiorWallStriped -> door2 band2 col0
    interiorWallStripedDoorAboveAnim1: 27036,
    interiorWallStripedDoorAboveAnim2: 27037,
    interiorWallStripedDoorAboveAnim3: 27038,
    interiorWallStripedDoorTopAnim1: 27042,
    interiorWallStripedDoorTopAnim2: 27043,
    interiorWallStripedDoorTopAnim3: 27044,
    interiorWallStripedDoorBottomAnim1: 27048,
    interiorWallStripedDoorBottomAnim2: 27049,
    interiorWallStripedDoorBottomAnim3: 27050,

    // Double-leaf (door3): {style}Door{Above|Top|Bottom}{Left|Right}Anim{1|2|3}
    // portcullis -> ironholdKeep
    // strongDoor, steelDoor, goldenDoor: not currently mapped to a material, available for reuse
    // strongDoor -> door3 band0
    strongDoorAboveLeftAnim1: 28000,
    strongDoorAboveRightAnim1: 28001,
    strongDoorAboveLeftAnim2: 28002,
    strongDoorAboveRightAnim2: 28003,
    strongDoorAboveLeftAnim3: 28004,
    strongDoorAboveRightAnim3: 28005,
    strongDoorTopLeftAnim1: 28012,
    strongDoorTopRightAnim1: 28013,
    strongDoorTopLeftAnim2: 28014,
    strongDoorTopRightAnim2: 28015,
    strongDoorTopLeftAnim3: 28016,
    strongDoorTopRightAnim3: 28017,
    strongDoorBottomLeftAnim1: 28024,
    strongDoorBottomRightAnim1: 28025,
    strongDoorBottomLeftAnim2: 28026,
    strongDoorBottomRightAnim2: 28027,
    strongDoorBottomLeftAnim3: 28028,
    strongDoorBottomRightAnim3: 28029,

    // steelDoor -> door3 band1
    steelDoorAboveLeftAnim1: 28036,
    steelDoorAboveRightAnim1: 28037,
    steelDoorAboveLeftAnim2: 28038,
    steelDoorAboveRightAnim2: 28039,
    steelDoorAboveLeftAnim3: 28040,
    steelDoorAboveRightAnim3: 28041,
    steelDoorTopLeftAnim1: 28048,
    steelDoorTopRightAnim1: 28049,
    steelDoorTopLeftAnim2: 28050,
    steelDoorTopRightAnim2: 28051,
    steelDoorTopLeftAnim3: 28052,
    steelDoorTopRightAnim3: 28053,
    steelDoorBottomLeftAnim1: 28060,
    steelDoorBottomRightAnim1: 28061,
    steelDoorBottomLeftAnim2: 28062,
    steelDoorBottomRightAnim2: 28063,
    steelDoorBottomLeftAnim3: 28064,
    steelDoorBottomRightAnim3: 28065,

    // goldenDoor -> door3 band2
    goldenDoorAboveLeftAnim1: 28072,
    goldenDoorAboveRightAnim1: 28073,
    goldenDoorAboveLeftAnim2: 28074,
    goldenDoorAboveRightAnim2: 28075,
    goldenDoorAboveLeftAnim3: 28076,
    goldenDoorAboveRightAnim3: 28077,
    goldenDoorTopLeftAnim1: 28084,
    goldenDoorTopRightAnim1: 28085,
    goldenDoorTopLeftAnim2: 28086,
    goldenDoorTopRightAnim2: 28087,
    goldenDoorTopLeftAnim3: 28088,
    goldenDoorTopRightAnim3: 28089,
    goldenDoorBottomLeftAnim1: 28096,
    goldenDoorBottomRightAnim1: 28097,
    goldenDoorBottomLeftAnim2: 28098,
    goldenDoorBottomRightAnim2: 28099,
    goldenDoorBottomLeftAnim3: 28100,
    goldenDoorBottomRightAnim3: 28101,

    // portcullis (ironholdKeep) -> door3 band3
    portcullisDoorAboveLeftAnim1: 28108,
    portcullisDoorAboveRightAnim1: 28109,
    portcullisDoorAboveLeftAnim2: 28110,
    portcullisDoorAboveRightAnim2: 28111,
    portcullisDoorAboveLeftAnim3: 28112,
    portcullisDoorAboveRightAnim3: 28113,
    portcullisDoorTopLeftAnim1: 28120,
    portcullisDoorTopRightAnim1: 28121,
    portcullisDoorTopLeftAnim2: 28122,
    portcullisDoorTopRightAnim2: 28123,
    portcullisDoorTopLeftAnim3: 28124,
    portcullisDoorTopRightAnim3: 28125,
    portcullisDoorBottomLeftAnim1: 28132,
    portcullisDoorBottomRightAnim1: 28133,
    portcullisDoorBottomLeftAnim2: 28134,
    portcullisDoorBottomRightAnim2: 28135,
    portcullisDoorBottomLeftAnim3: 28136,
    portcullisDoorBottomRightAnim3: 28137,

    // Scifi sliding doors (2 tiles tall) - only 2 frames, open and closed
    scifiSlidingDoorTopAnim1: 27027,
    scifiSlidingDoorTopAnim2: 27028,
    scifiSlidingDoorBottomAnim1: 27033,
    scifiSlidingDoorBottomAnim2: 27034,

  // ── Icons sheet tiles (globalId = 20000 + localTileIndex) ──
  coin:        20199,
  playingCard: 20222,
  fishingHook: 20257,
  worm:        20258,
  bait:        20267,
  bottle:      20307,

      evilFace: 20004,
          goldNecklace: 20134,
    oldeKey: 20185,
    pileOfCopperCoins: 20200,
    pileOfSilverCoins: 20201,
    pileOfGoldCoins: 20202,

        boxerShorts: 20124,
    letter: 20217,
    dice: 20221,
    garlic: 20232,
    steak: 20241,
    eggs: 20245,
    egg: 20246,
    stick: 20272,
    diamond: 20276,
    cotton: 20277,
    knitting: 20278,
    feather: 20282,

        goldRing: 20132,
    diamondRing: 20133,
} as const